/**
 * @Description: 暂无描述
 * @Author: jiangang
 * @Date: 2022-03-29
 * @LastEditTime: 13:57:03
 * {
 *   icon: 菜单图标，
 *   path： 菜单跳转路径
 *   title： 页面title
 *   name： 跳转组件name
 * }
 */
const iot = [
  {
    icon: 'iconfont cl-icon-IOTshebei',
    title: 'IoT设备管理',
    id: 1,
    children: [{
      title: '设备管理',
      icon: 'iconfont cl-icon-IOT',
      path: '/device/device/index',
      name: 'deviceManage',
      requireAuth: false,
      keepAlive: true,
      id: 111,
    }, {
      title: '设备详情',
      icon: 'iconfont cl-icon-IOT',
      path: '/device/device/detail',
      name: 'deviceDetail',
      requireAuth: false,
      keepAlive: false,
      id: 112,
      pid: 111, // 隐藏菜单配合active使用,pid设置为想要active的菜单的ID
      hide: true
    },
    {
      title: '分组管理',
      icon: 'iconfont cl-icon-fenzu',
      path: '/device/group/index',
      name: 'groupManage',
      requireAuth: false,
      keepAlive: true,
      id: 121,
    },
    {
      title: '分组管理详情',
      icon: 'iconfont cl-icon-fenzu',
      path: '/device/group/detail',
      name: 'groupManageDetail',
      keepAlive: true,
      id: 122,
      pid: 121,
      hide: true
    }, {
      title: '产品管理',
      icon: 'iconfont cl-icon-chanpinguanli',
      path: '/device/product/index',
      name: 'productManage',
      keepAlive: true,
      hide: true,
      id: 13,
    }],
  }, {
    icon: 'iconfont cl-icon-yunweiguanli',
    title: '设备运维',
    id: 2,
    name: 'deviceOperation',
    children: [
      {
        title: 'OTA升级',
        icon: 'iconfont cl-icon-shengji',
        path: '/device-operation/ota',
        name: 'otaUpgradeList',
        id: 21,
        keepAlive: true,
        component: '/deviceOperation/ota/OtaUpgradeList',
      },
      {
        title: '远程运维',
        icon: 'iconfont cl-icon-yuanchengkongzhi',
        path: '/device-operation/remote',
        name: 'remoteOperation',
        id: 22,
        keepAlive: true,
        component: '/deviceOperation/remote/RemoteOperation',
      }
    ]
  },
  {
    title: '数据管理',
    icon: 'iconfont cl-icon-shujuguanli',
    name: 'commonPage',
    id: 3,
    children: [
      {
        title: '数据管理',
        icon: 'iconfont cl-icon-shujuguanli',
        path: '/dataManage/index',
        name: 'dataManage',
        id: 31
      }, {
        title: '数据详情',
        icon: 'iconfont cl-icon-shujuguanli',
        path: '/dataManage/detail',
        name: 'dataManageDetail',
        id: 32,
        pid: 31,
        hide: true
      },
      {
        title: '监控中心',
        icon: 'iconfont cl-icon-weiwangguanicon-defuben-',
        name: 'commonPage',
        id: 33,
        children: [
          {
            title: '告警管理',
            icon: 'iconfont cl-icon-gaojingguanli',
            path: '/monitorCenter/alarmManage',
            name: 'alarmManage',
            id: 331
          }, {
            title: '告警记录',
            icon: 'iconfont cl-icon-gaojingjilu',
            path: '/monitorCenter/alarmRecord',
            name: 'alarmRecord',
            id: 332,
          }]
      }, {
        icon: 'iconfont cl-icon-shujudingyue',
        title: '数据订阅',
        id: 34,
        name: 'dataSubscrip',
        path: '/dataSubscrip/index'
      }, {
        title: '标签管理',
        icon: 'iconfont cl-icon-shujubiaoqian',
        path: '/dataManage/labelManage',
        name: 'dataLabel',
        id: 35,
      }],
  }, {
    icon: 'iconfont cl-icon-icon-sfq36',
    title: '设备生命周期管理',
    id: 4,
    name: 'equipmentManage',
    children: [
      {
        title: '设备管理',
        icon: 'iconfont cl-icon-gongyeshebei',
        path: '/equipment/',
        name: 'equipment',
        id: 41
      }, {
        title: '设备详情',
        icon: 'iconfont cl-icon-IOT',
        path: '/equipment/detail',
        name: 'equipmentDetail',
        requireAuth: false,
        keepAlive: false,
        id: 42,
        pid: 41, // 隐藏菜单配合active使用,pid设置为想要active的菜单的ID
        hide: true
      }, {
        title: '备件管理',
        icon: 'iconfont cl-icon-beijianguanli',
        path: '/equipment/stock',
        name: 'componentStock',
        id: 43
      }, {
        title: '部件类型管理',
        icon: 'iconfont cl-icon-duogangchaiyouji',
        path: '/equipment/component',
        name: 'equipmentComponent',
        id: 44
      }, {
        title: '保养管理',
        name: 'maintain',
        id: 45,
        children: [{
            title: '保养计划',
            path: '/maintain/plan',
            name: 'maintainPlan',
            id: 451
          },{
            title: '保养任务',
            path: '/maintain/task',
            name: 'maintainTask',
            id: 452
          },{
            title: '保养内容',
            path: '/maintain/setting',
            name: 'maintainSetting',
            id: 453
          }, {
            title: '任务详情',
            icon: 'iconfont cl-icon-IOT',
            path: '/maintain/task/detail',
            name: 'maintainTaskDetail',
            requireAuth: false,
            keepAlive: false,
            id: 454,
            pid: 452, // 隐藏菜单配合active使用,pid设置为想要active的菜单的ID
            hide: true
          }]
      },]
  }, {
    icon: 'iconfont cl-icon-xitongguanli1',
    title: '系统管理',
    id: 5,
    name: 'systemManage',
    children: [
      {
        title: '灯塔系统',
        icon: 'iconfont cl-icon-dengta',
        path: '/system/lighthouseSystem',
        name: 'lighthouseSystem',
        id: 51
      }]
  },
]
module.exports = {
  menuList: {
    iot
  },
}
